import { ReportField } from '@modules/reports/Domain/reports.model';

export const ClientsReportFields: ReportField[] = [
  {
    name: 'collectorId',
    type: 'dropdown',
    options: [],
    required: false,
  },
];

export const PanelReportFields: ReportField[] = [
  {
    name: 'collectorId',
    type: 'dropdown',
    options: [],
    required: true,
  },
];

export const PanelReportV2Fields: ReportField[] = [
  {
    name: 'collectorId',
    type: 'dropdown',
    options: [],
    required: false,
  },
  {
    name: 'startDate',
    label: 'dateNotification',
    type: 'date',
    dateView: 'month',
    required: true,
    isMonthPeriod: true,
    tooltip: 'DATA.MODULES.REPORTS.TOOLTIP.dateNotification',
  },
];

export const GlobalPortfolioReportFields: ReportField[] = [
  {
    name: 'collectorId',
    type: 'dropdown',
    options: [],
    tooltip: 'DATA.MODULES.REPORTS.TOOLTIP.PORTFOLIO',
  },
  {
    name: 'dateRange',
    type: 'dateRange',
    required: true,
  },
];

export const CollectorsReportFields: ReportField[] = [
  { name: 'collectorId', type: 'dropdown', options: [] },
  {
    name: 'dateRange',
    type: 'dateRange',
    required: true,
    tooltip: 'DATA.MODULES.REPORTS.TOOLTIP.COLLECTORS_PERIOD',
  },
];

export const NotificationsReportFields: ReportField[] = [
  {
    name: 'collectorId',
    type: 'dropdown',
    options: [],
  },
  {
    name: 'dateRange',
    type: 'dateRange',
    required: true,
  },
];

export const OutboundCallsReportFields: ReportField[] = [
  {
    name: 'period',
    type: 'dateRange',
    required: true,
  },
];

export const CollectionPeriodReportFields: ReportField[] = [
  {
    name: 'period',
    type: 'dateRange',
    required: true,
    tooltip: 'DATA.MODULES.REPORTS.TOOLTIP.COLLECTION',
  },
  { name: 'collectorId', type: 'dropdown', options: [] },
];

export const CampaignsByMonthReportFields: ReportField[] = [
  {
    name: 'startDate',
    label: 'dateNotification',
    type: 'date',
    dateView: 'month',
    required: true,
    tooltip: 'DATA.MODULES.REPORTS.TOOLTIP.dateNotification',
  },
  { name: 'campaignId', type: 'dropdown', options: [], required: true },
  { name: 'collectorId', type: 'dropdown', options: [] },
];

export const DueDatePeriodReportFields: ReportField[] = [
  {
    name: 'startDate',
    type: 'date',
    dateView: 'month',
    required: true,
  },
];

export const DebtAgingReportFields: ReportField[] = [
  {
    name: 'dateRange',
    type: 'dateRange',
    required: true,
  },
];

export const CollectionMonthReportFields: ReportField[] = [
  {
    name: 'dateNotification',
    type: 'date',
    label: 'monthCreation',
    dateView: 'month',
    isMonthRange: true,
    required: true,
    tooltip: 'DATA.MODULES.REPORTS.TOOLTIP.monthCreation',
  },
  { name: 'campaignId', type: 'dropdown', options: [], label: 'campaignRestore' },
  { name: 'collectorId', type: 'dropdown', options: [] },
  {
    name: 'months',
    type: 'dropdown',
    required: true,
  },
  {
    name: 'portfolioId',
    type: 'dropdown',
    required: false,
    options: [],
  },
  {
    name: 'ignoreOperationStatus',
    type: 'dropdown',
    options: [],
  },
];
